import { Component, Input, OnInit } from '@angular/core';
declare var $: any; 

@Component({
  selector: 'app-scora-image-view',
  templateUrl: './scora-image-view.component.html',
  styleUrls: ['./scora-image-view.component.css']
})
export class ScoraImageViewComponent implements OnInit {

  @Input() imageUrl: any;
  selectedData = ''
  constructor() { }

  ngOnInit() {
  }
  open_image_view(data) {
    this.selectedData = data;
    $('#image-view').modal('show');
  }
}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-image-view/scora-image-view.component.ts